import { useMe } from '@/platform/auth/use-me';
import { OverflowTabNav } from '@/platform/components/overflow-tab-nav';
import { masterDataNavItems } from '@/platform/lib/master-data-paths';

export function MasterDataNav() {
  const me = useMe();
  return <OverflowTabNav items={masterDataNavItems(me.data)} ariaLabel="Stammdaten" />;
}
